import React from 'react'

export const Tasks = () => {
  return (
    <div>Tasks Building soon.......</div>
  )
}
